<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>{{icon}}</v-icon>
      <h2 class="title ml-2">{{title}}</h2>
    </v-card-title>
    <v-card-text>
      <v-form ref="data" v-if="value">
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              :items="dias"
              item-text="label"
              item-value="value"
              label="Día"
              v-model="value.dia"
              :error-messages="errDia"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="value.nombre"
              label="Nombre"
              :error-messages="errNombre"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="value.inicio"
              label="Inicia a las"
              type="time"
              :error-messages="errInicio"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="value.fin"
              label="Termina a las"
              type="time"
              :error-messages="errFin"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-textarea
          v-model="value.descripcion"
          label="Descripción"
          :error-messages="errDescripcion"
        ></v-textarea>
        <!-- <v-file-input
          label="Imagen"
          v-model="value.imagen"
          show-size
          accept="image/*"
        ></v-file-input>
        <v-row v-if="value.imagen && value.imagen.url" justify="center">
          <v-card>
            <v-card-text>
              <v-img
                :src="urlImg"
                max-width="300"
                max-height="200"
              ></v-img>
            </v-card-text>
          </v-card>
        </v-row> -->
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" @click="$emit('close')">
        <v-icon left>fas fa-times</v-icon>
        Cerrar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="save()">
        <v-icon left>fas fa-save</v-icon>
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import dias from '../helpers/dias'
import { required } from 'vuelidate/lib/validators'
import { host } from '../config'
import dayjs from 'dayjs'
const esHora = (value) => {
  return new RegExp(/([0-2][0-9]):([0-5][0-9])/g).test(value)
}
const menorQue = (value, vm) => {
  if (value || vm.fin) {
    return dayjs(`2006-01-02T${value}`).unix() < dayjs(`2006-01-02T${vm.fin}`).unix()
  } else {
    return false
  }
}
export default {
  name: 'edit-programa',
  props: ['icon', 'title', 'value'],
  data () {
    return {
      dias
    }
  },
  computed: {
    errDia () {
      const errs = []
      if (!this.$v.value.dia.$dirty) return errs
      !this.$v.value.dia.required && errs.push('El dia es requerido')
      return errs
    },
    errDescripcion () {
      const errs = []
      if (!this.$v.value.descripcion.$dirty) return errs
      !this.$v.value.descripcion.required && errs.push('La descrición es requerida')
      return errs
    },
    errNombre () {
      const errs = []
      if (!this.$v.value.nombre.$dirty) return errs
      !this.$v.value.nombre.required && errs.push('El nombre es requerido')
      return errs
    },
    errInicio () {
      const errs = []
      if (!this.$v.value.inicio.$dirty) return errs
      !this.$v.value.inicio.required && errs.push('La hora de inicio es requerida')
      !this.$v.value.inicio.menorQue && errs.push('La hora de inicio es mayor que la hora de finalizacion')
      return errs
    },
    errFin () {
      const errs = []
      if (!this.$v.value.fin.$dirty) return errs
      !this.$v.value.fin.required && errs.push('La hora de finalizacion es requerida')
      return errs
    },
    urlImg () {
      return this.value.imagen.url ? `${host}${this.value.imagen.url}` : ''
    }
  },
  methods: {
    save () {
      this.$v.value.$touch()
      if (!this.$v.value.$invalid) {
        this.$emit('save', this.value.dia)
      }
    },
    reset () {
      this.$refs['data'].reset()
      this.$v.value.$reset()
    }
  },
  validations: {
    value: {
      descripcion: { required },
      dia: { required },
      nombre: { required },
      inicio: {
        required,
        esHora,
        menorQue
      },
      fin: {
        required,
        esHora
      }
    }
  }
}
</script>
